class LayoutTemplates {
    static templates = [
        {
            "layout_id": 1,
            "layout_name": "Portrait",
            "background_color": "#000000",
            "width": "1080px",
            "height": "1920px",
            "slots": [
                {
                    "slot_id": "slot_1",
                    "x": "0px",
                    "y": "0px",
                    "width": "1080px",
                    "height": "1920px",
                    "zindex": 0
                }
            ]
        },
        {
            "layout_id": 2,
            "layout_name": "Landscape",
            "background_color": "#000000",
            "width": "1920px",
            "height": "1080px",
            "slots": [
                {
                    "slot_id": "slot_1",
                    "x": "0px",
                    "y": "0px",
                    "width": "1920px",
                    "height": "1080px",
                    "zindex": 0
                }
            ]
        },
        {
            "layout_id": 3,
            "layout_name": "Portrait (Split 2)",
            "background_color": "#000000",
            "width": "1080px",
            "height": "1920px",
            "slots": [
                {
                    "slot_id": "slot_1",
                    "x": "0px",
                    "y": "0px",
                    "width": "1080px",
                    "height": "960px",
                    "zindex": 0
                },

                {
                    "slot_id": "slot_2",
                    "x": "0px",
                    "y": "960px",
                    "width": "1080px",
                    "height": "960px",
                    "zindex": 0
                }
            ]
        },
        {
            "layout_id": 4,
            "layout_name": "Landscape (Split 2)",
            "background_color": "#000000",
            "width": "1920px",
            "height": "1080px",
            "slots": [
                {
                    "slot_id": "slot_1",
                    "x": "0px",
                    "y": "0px",
                    "width": "960px",
                    "height": "1080px",
                    "zindex": 0
                },

                {
                    "slot_id": "slot_2",
                    "x": "960px",
                    "y": "0px",
                    "width": "960px",
                    "height": "1080px",
                    "zindex": 0
                }
            ]
        },
        {
            "layout_id": 5,
            "layout_name": "Portrait (Split 3)",
            "background_color": "#000000",
            "width": "1080px",
            "height": "1920px",
            "slots": [
                {
                    "slot_id": "slot_1",
                    "x": "0px",
                    "y": "0px",
                    "width": "1080px",
                    "height": "640px",
                    "zindex": 0
                },

                {
                    "slot_id": "slot_2",
                    "x": "0px",
                    "y": "640px",
                    "width": "1080px",
                    "height": "640px",
                    "zindex": 0
                },

                {
                    "slot_id": "slot_3",
                    "x": "0px",
                    "y": "1280px",
                    "width": "1080px",
                    "height": "640px",
                    "zindex": 0
                }
            ]
        },
        {
            "layout_id": 6,
            "layout_name": "Landscape (Split 3)",
            "background_color": "#000000",
            "width": "1920px",
            "height": "1080px",
            "slots": [
                {
                    "slot_id": "slot_1",
                    "x": "0px",
                    "y": "0px",
                    "width": "640px",
                    "height": "1080px",
                    "zindex": 0
                },

                {
                    "slot_id": "slot_2",
                    "x": "640px",
                    "y": "0px",
                    "width": "640px",
                    "height": "1080px",
                    "zindex": 0
                },

                {
                    "slot_id": "slot_3",
                    "x": "1280px",
                    "y": "0px",
                    "width": "640px",
                    "height": "1080px",
                    "zindex": 0
                }
            ]
        },
    ]
}

export default LayoutTemplates